////lazy load block images
//if (!!window.IntersectionObserver) {
//    var observer = new IntersectionObserver(function (entries, observer) {
//        entries.forEach(function (entry) {
//            if (entry.isIntersecting) {
//                if (entry.target.dataset && entry.target.dataset.src) {
//                    entry.target.src = entry.target.dataset.src;
//                    observer.unobserve(entry.target);
//                }

//            }
//        });
//    },
//        {});
//    [].slice.call(document.querySelectorAll('img')).forEach(function (img) { observer.observe(img); });
//} else { //load all images now
//    [].slice.call(document.querySelectorAll('img')).forEach(function (entry) {
//        if (entry.target.dataset && entry.target.dataset.src) {
//            entry.target.src = entry.target.dataset.src;
//            observer.unobserve(entry.target);
//        }
//    });
//}